import React from 'react';
import { Users, Wifi, WifiOff } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../ui/tooltip';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';

export default function CanvasPresence({ users, isConnected }) {
  const maxVisible = 4;
  const visibleUsers = (users || []).slice(0, maxVisible);
  const extraCount = (users || []).length - maxVisible;

  return (
    <TooltipProvider>
      <div className="flex items-center gap-3">
        {/* Connection status */}
        <Tooltip>
          <TooltipTrigger>
            <div className={`flex items-center gap-1.5 px-2 py-1 rounded-full text-xs ${
              isConnected 
                ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400' 
                : 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400'
            }`}>
              {isConnected ? (
                <>
                  <Wifi className="h-3 w-3" />
                  <span>Live</span>
                </>
              ) : (
                <>
                  <WifiOff className="h-3 w-3" />
                  <span>Offline</span>
                </>
              )}
            </div>
          </TooltipTrigger>
          <TooltipContent>
            {isConnected ? 'Connected to real-time collaboration' : 'Reconnecting...'}
          </TooltipContent>
        </Tooltip>

        {/* Active users */}
        {visibleUsers.length > 0 && (
          <div className="flex items-center">
            <div className="flex -space-x-2">
              {visibleUsers.map((user, index) => (
                <Tooltip key={user.user_id || index}>
                  <TooltipTrigger>
                    <Avatar 
                      className="h-8 w-8 border-2 border-background"
                      style={{ borderColor: user.color }}
                    >
                      <AvatarImage src={user.avatar_url} alt={user.user_name} />
                      <AvatarFallback 
                        className="text-xs font-medium"
                        style={{ backgroundColor: user.color, color: '#FFFFFF' }}
                      >
                        {user.user_name?.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase() || '?'}
                      </AvatarFallback>
                    </Avatar>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>{user.user_name}</p>
                  </TooltipContent>
                </Tooltip>
              ))}
              
              {extraCount > 0 && (
                <Tooltip>
                  <TooltipTrigger>
                    <div className="h-8 w-8 rounded-full bg-muted border-2 border-background flex items-center justify-center">
                      <span className="text-xs font-medium text-muted-foreground">+{extraCount}</span>
                    </div>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>{extraCount} more user{extraCount > 1 ? 's' : ''}</p>
                  </TooltipContent>
                </Tooltip>
              )}
            </div>
            
            <span className="ml-2 text-sm text-muted-foreground hidden sm:inline">
              {users.length} online
            </span>
          </div>
        )}
      </div>
    </TooltipProvider>
  );
}
